import React from "react";

export function CheckedInIcon({ name }: {
    name: "back" | "forward" | "search" | "close";
}): React.ReactElement {
    return <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor"
        strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {name === "back" && <path d="m15 4-8 8 8 8" />}
        {name === "forward" && <path d="m9 4 8 8-8 8" />}
        {name === "close" && <path d="m5 5 14 14M5 19 19 5" />}
        {name === "search" && <><circle cx="10" cy="10" r="7" /><path d="m15 15 6 6" /></>}
    </svg>;
}
